import { AuthUserHook } from '@/models/Hooks.ts';

import { useAuthStore } from '@/stores/authStore.ts';

const useAuth = (): AuthUserHook => {
    const { user: authUser, userEmail: email } = useAuthStore();

    return {
        authUser,
        email,
    };
};

export default useAuth;
